<template>
  <div class="vz-news-list">
    <div v-for="(item, i) in items" :key="i">
      <vz-news-card :item="item" />
    </div>
    <span ref="el"></span>
  </div>
</template>

<script setup lang="ts">
import {PropType} from 'vue';
import {useIntersectionObserver} from '@vueuse/core';
import {getNews} from '~/api/home';
import VzNewsCard from '~/components/public/news/vz-news-card.vue';

const props = defineProps({
  tag: {
    type: String as PropType<'news'|'actions'>,
    default: 'news'
  },
})

const el = ref<HTMLElement>()
const perPage = 20
const items = ref<any[]>([])

async function loadMore() {
  // Todo вызывается 2 раза
  const moreData = await getNews(
    Math.ceil(items.value.length / perPage + 1),
    { sort: '-date', is_action: props.tag === 'actions' ? 1 : 0 }
  )
  if (moreData) {
    items.value.push(...moreData)
  }
}

useIntersectionObserver(
  el,
  loadMore,
  {
    threshold: 0.5,
  }
)

// ssr
await loadMore()
</script>

<style scoped lang="scss">
.vz-news-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 20px;
  grid-row-gap: 80px;

  @media screen and (max-width: $pub-md) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: $pub-xs) {
    grid-template-columns: 1fr;
  }
}
</style>
